// src/components/Bits.jsx
//
// Small pieces shared by both pages. Reveal and Eyebrow match the ones in the
// Cold Storage site's Sections.jsx.

import React, { useEffect, useRef } from "react";
import { motion, useInView } from "motion/react";

export function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-70px" });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 18 }}
      animate={seen ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p
      className={`font-mono text-[10px] uppercase tracking-[0.22em] text-brooke-red ${className}`}
    >
      {children}
    </p>
  );
}

// Keeps the browser tab honest per page
export function useTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
